<template >
 <div v-if="payment" class="form-group">
    
    <div class="input-group">
        <div class="input-group-prepend">
          
          <div :style="{backgroundColor : '#b335e9', color:'white',width:'150px'}" class="input-group-text"><strong>{{payment}}</strong>  </div>
            <span class="input-group-text"> €</span>
          </div>

      <input :disabled="disabled"  @input="setTotal()" ref="inputOtherPayment" type="number" step="0.01"  :style="{fontSize: '30px'}" class="form-control" id="inputOtherPayment" :placeholder="payment" v-model="total">
      

  </div>
  
  </div>

    </template>
    <script>
    import api                      from '@/api'
    import { mapGetters }             from 'vuex';
          
    export default {
     
      props : ['disabled'], 
      
     data () {
        return {
        
        total     : 0.00,
        payment   : ''

        
        
        
    
        }
      },

      computed: {
        ...mapGetters(['company','storeId']) 
      },

    mounted()
    {
         this.getData()  
         this.total = this.total.toFixed(2)
    },  
    created()
    {
      
      
      
      
    },
    methods : {

    setTotal()
    {
      this.$emit('update',this.total,this.payment)
        
    },
    async getData() 
    {
      

     
      
      this.payment = ''
      const sp    = {'sp'        : 'spCompanyOtherPayment'} 
      const data  = {'companyId' : this.company.Id}
      const json  = Object.assign(data, sp)
      
      await api.post(json).then(res => {
        if(res.status==200)
          {
           
            if(res.data.recordsets[0].length > 0 )
            {
              this.payment = res.data.recordsets[0][0].payment
              this.$emit('update','0.00',this.payment)
                            
            }

            
                 
          }
          else if(res.status==500)
          {
            console.log(res)        
          
          } 
          else
          {
            
          
          } 
      }).catch(err => 
      {

        
        console.log(err.message)    
        /*
        this.msg.title = 'ATTENZIONE '
        this.msg.body = err.message
        this.msg.type = 1
        */

      }).finally(() => {
        
      });
    },



    
    
}
}
    </script>
    <style scoped>
    input{
        font-size: 24px;
    }
    
    </style>
    